import React from 'react';

const PrivacyPolicy = () => (
  <div style={{ padding: '2rem', lineHeight: '1.6' }}>
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> October 29, 2025</p>
    <p>Mercadito AI LLC ("we", "us", "our") respects your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services through our website, chatbot, or integrations (such as WhatsApp Business, Stripe, and others).</p>
    <h2>1. Information We Collect</h2>
    <ul>
      <li><strong>Personal Information</strong>: Name, phone number, email, business name, location.</li>
      <li><strong>Communication Data</strong>: Messages sent via WhatsApp or forms.</li>
      <li><strong>Transactional Data</strong>: Payments made via Stripe or connected services.</li>
      <li><strong>Usage Data</strong>: Analytics data, page views, user behavior.</li>
    </ul>
    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>Provide and improve our platform and services.</li>
      <li>Send important updates and onboarding materials.</li>
      <li>Process payments and generate receipts (via Stripe).</li>
      <li>Analyze trends and improve features.</li>
    </ul>
    <h2>3. Sharing Your Information</h2>
    <p>We only share your data with trusted providers (360dialog, Stripe) or legal authorities if required. We do not sell your data.</p>

    <h2>4. Security</h2>
    <p>We use industry-standard encryption and access controls to protect your data.</p>

    <h2>5. Your Rights (California Residents – CCPA)</h2>
    <p>Request access, deletion, or opt out by emailing <a href="mailto:support@mercaditoai.com">support@mercaditoai.com</a>.</p>

    <h2>6. Cookies & Tracking</h2>
    <p>Our site uses cookies for analytics. You may disable cookies in your browser settings.</p>

    <h2>7. Contact Us</h2>
    <p>Mercadito AI LLC – California, USA  
    <br />Email: <a href="mailto:support@mercaditoai.com">support@mercaditoai.com</a></p>
  </div>
);

export default PrivacyPolicy;